<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
      {{ successMessage }}
    </div>
    <b-card>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="addUser" v-if="show">
            <div style="
                  background-color: rgb(97, 116, 152);
                  height: 32px;
                  border-radius: 4px;
                ">
              <h4 style="
                    color: rgb(223, 227, 238);
                    margin-left: 5px;
                    font-weight: bold;
                  ">
                Product Information
              </h4>
            </div>
            <div class="row">
              <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Title:" label-for="name">
                  <b-form-input id="name" placeholder="Enter name" v-model="name" disabled>
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Amount:" label-for="price">
                  <b-form-input id="price" placeholder="Enter price" v-model="price" disabled>
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Description:" label-for="description">
                  <textarea class="form-control" id="description" type="text"
                  placeholder="Enter message" v-model="description" disabled/>
                </b-form-group>
              </div>

              <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Quantity:" label-for="quantity">
                  <b-form-input id="quantity" placeholder="Enter quantity" v-model="quantity" disabled>
                  </b-form-input>
                </b-form-group>
              </div>
              <div v-if="lightboxVisible" class="lightbox" @click="closeLightbox">
                <div class="lightbox-content">
                  <img :src="selectedImage" alt="Vehicle Image" class="lightbox-image" />
                </div>
              </div>

              <div class="col-md-12 col-12">
                <b-form-group id="input-group-2" label="Product Pictures:" label-for="image">
                  <!-- Check if images are available -->
                  <div v-if="image && image.length > 0" class="d-flex flex-wrap">
                    <div v-for="(img, index) in image" :key="index" style="margin-right: 10px; margin-bottom: 10px">
                      <img :src="'https://wossdb.wossautoid.com/' + img" alt="Product Picture" width="100" height="100"
                        @click="openLightbox(img)" />
                    </div>
                  </div>
                  
                  <div v-else>
                    <span>No image available</span>
                  </div>
                </b-form-group>
              </div>

            </div>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BFormSelect,
  BFormInput,
  BSpinner,
  BToast,
} from "bootstrap-vue";
import axios from "../../../axios";
export default {
  data() {
    return {
      show: true,
      description: "",
      name: "",
      price: "",
      quantity: '',
      // image: '',
      image: [],
      lightboxVisible: false,
      selectedImage: '',
      successMessage:"",
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BToast,
    BSpinner,
  },
  created() {
    axios
    const userId = this.$route.params.id;
    axios
      .get(`ProductShow/${userId}`)
      .then((response) => {

        this.editedUser = response.data.data;
        this.name = this.editedUser.name;
        this.price = this.editedUser.price;
        this.image = this.editedUser.image || '';
        this.description = this.editedUser.description || '';
        this.quantity = this.editedUser.quantity || '';
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  },
  methods: {
    openLightbox(imgPath) {
      this.selectedImage = `https://wossdb.wossautoid.com/${imgPath}`;
      this.lightboxVisible = true;
    },
    closeLightbox() {
      this.lightboxVisible = false;
    },
    showMsgBoxOne() {
      debugger;
    },
    onSubmit(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));

    },
    codeClick() {
      this.codeActive = !this.codeActive;
    },

    saveOwnCar() {
      this.showModal = false;
    },
  },
};
</script>


<style>
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.lightbox-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}

.lightbox-image {
  max-width: 100%;
  max-height: 80vh;
}
</style>